<!-- 贴单登记-->
<template>
  <div>
        <ctrl-box class="ctrl-box">
            <template>
                <div class="xgroup">
                    <el-link :underline="false" @click="showQuery = !showQuery">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-search" font-size="27px;"/>
                            <span class="txt" >{{msg('搜索')}}</span>      
                        </div>                
                    </el-link>
                    <el-link :underline="false" @click="doExport()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-daochu2" font-size="27px;"/>
                            <span class="txt">{{msg('导出')}}</span>      
                        </div>         
                    </el-link>
                    <el-link :underline="false" @click="doRecordCount()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-tongji" font-size="27px;"/>
                            <span class="txt">{{msg('计数统计')}}</span>      
                        </div>         
                    </el-link>
                    <el-link :underline="false" @click="doRecordCountDistinct()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-tongji" font-size="27px;"/>
                            <span class="txt">{{msg('去重统计')}}</span>      
                        </div>         
                    </el-link>
                    <el-link :underline="false" @click="doRecordCountUser()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-tongji" font-size="27px;"/>
                            <span class="txt">{{msg('账号统计')}}</span>      
                        </div>         
                    </el-link>
                    <el-link :underline="false" @click="openHelp()">
                        <div class="wrap" >
                            <icon-svg icon-class="icon-tishi2" font-size="27px;"/>
                            <span class="txt">{{msg('帮助')}}</span>      
                        </div>
                    </el-link>
                </div>
            </template>
        </ctrl-box>
 
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <el-form-item :label="msg('订单编号')">
                        <el-input type="textarea"  :rows="3" v-model="scope.query.codes" style="margin-top:0px;">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="msg('操作人员')">
                        <el-input type="textarea"  :rows="3" v-model="scope.query.createNames" style="margin-top:0px;">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="msg('操作账号')">
                        <el-input type="textarea"  :rows="3" v-model="scope.query.userNames" style="margin-top:0px;">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="msg('操作类型')">
                        <el-select v-model="scope.query.type" placeholder="请选择" clearable>
                            <el-option
                            v-for="item in dicts.pasteRecordTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="msg('操作时间')" label-width="80px" clearable>
                        <el-date-picker  v-model="query.Date" type="datetimerange"  :range-separator="msg('至')" 
                            value-format="yyyy-MM-dd HH:mm:ss"
                            end-placeholder=""
                            size="small"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>

        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight" 
                export-config
                resizable border="full"
                :cell-style="{width:'80px;',height:'80px'}"
                show-overflow highlight-hover-row
                highlight-current-row highlight-hover-column highlight-current-column
                :data="pasteRecords"
                :columns="columns"
                @cell-click="checkRow"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

        <el-dialog
            :title="recordRTitle"
            :visible.sync="recordVisiable"
            :close-on-click-modal="false"
            width="500px">
            <template>
                <el-table :data="recordData" height="500" border style="width: 100%">
                    <el-table-column prop="createName" label="姓名"></el-table-column>
                    <el-table-column prop="username" label="账号"></el-table-column>
                    <el-table-column prop="amount" label="数量"></el-table-column>
                </el-table>
            </template>
            
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="downloadResult">{{msg('导出')}}</el-button>
                <el-button type="primary" @click="copyResult">{{msg('复制')}}</el-button>
                <el-button type="danger" @click="recordVisiable = false">{{msg('关闭')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog
            :title="msg('账号统计')"
            :visible.sync="recordUserVisiable"
            :close-on-click-modal="false"
            width="600px">
            <el-form ref="form" label-width="80px">
                <el-form-item :label="msg('操作人员')">
                    <el-input v-model.trim="recordFullname" :placeholder="msg('请输入操作人员')"></el-input>
                </el-form-item>
                <el-form-item :label="msg('操作账号')">
                    <el-input v-model.trim="recordUsername" :placeholder="msg('请输入操作账号')"></el-input>
                </el-form-item>
                <el-form-item :label="msg('操作类型')">
                    <el-select v-model="type" placeholder="请选择" clearable>
                        <el-option
                        v-for="item in dicts.pasteRecordTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="msg('操作时间')">
                    <el-date-picker
                        v-model="created"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="msg('统计方法')">
                    <el-radio-group v-model="recordRadio" size="small">
                        <el-radio label="1">{{msg('计数统计')}}</el-radio>
                        <el-radio label="2">{{msg('去重统计')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="msg('数量')">
                    <el-tag effect="dark" type="success"><span style="font-size: 16px;font-weight: bold;">{{userRecordAmount}}</span></el-tag>
                </el-form-item>
            </el-form>
            
            <div style="text-align:center; margin-top: 15px;">
                <el-button type="primary" @click="doRecordUser()">{{msg('统计')}}</el-button>
                <el-button type="danger" @click="recordUserVisiable = false">{{msg('关闭')}}</el-button>
            </div>
        </el-dialog>
        <!--物流查詢-->
        <trace ref="traceRef"></trace>

    </div>  
</template>
<script>

import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import Trace from "../store/StockTrace.vue";
import XLSX from "xlsx";
export default {
    name: 'pasterecord',
    components:{
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        Trace: Trace,
    },
    mounted:function(){
        let endDate = new Date();
        let startDate = new Date(endDate - (24*3600*1000));
        this.query.Date = [
            this.$kit.fmtDateTime(startDate),
            this.$kit.fmtDateTime(endDate)
        ];
        this.buildColumns();
        this.list();
    },
    data(){
        return {
            query:{
                length: 10,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
                createNames:null,
                type:null,
                userNames:null,
                codes:null,
                Date: [], 
            },
            showQuery: false,
            curr: null,
            columns: [],
            pasteRecords: [],
            recordVisiable: false,
            recordData: [],
            recordRTitle:this.msg('计数统计'),
            recordUsername:null,
            created:[],
            type:null,
            recordRadio:"1",
            recordFullname:null,
            userRecordAmount:0,
            recordUserVisiable:false,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    methods: {
        buildColumns(){
            this.columns = [
                {type: 'checkbox', minWidth: 40},
                {field: 'id', title: this.msg('ID'), minWidth: 60, sortable: true},
                {field: 'code', title: this.msg('订单编号'), minWidth: 120, sortable: true,
                    slots: {
                        default: ({ row }) => {
                            return [
                                <span><i class="status-cell iconfont icon-trace font11"></i>{row.code}</span>
                            ];
                        }
                    },
                    filters:[{data: null}],
                    filterRender:{name: 'FilterInput'}
                },
                {field: 'type', title: this.msg('操作类型'), minWidth: 100, sortable: true,
                    slots: {
                        default: ({ row }) => {
                            let type = this.dicts.pasteRecordTypes.find(d => d.value === row.type);
                            return [
                                <el-tag type={type?type.type:''}>{type?type.label:row.type}</el-tag>
                            ];
                        }
                    },
                    filters:this.dicts.pasteRecordTypes
                },
                {field: 'created', title: this.msg('操作时间'), minWidth:100, sortable: true,
                    filters:[{data: []}],
                    filterRender:{name: 'ElDatePicker', props: {type: 'daterange', rangeSeparator: '至', startPlaceholder: '开始日期', endPlaceholder: '结束日期'}}
                },
                {field: 'createrName', title: this.msg('操作人员'), minWidth: 100, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'username', title: this.msg('操作账号'), minWidth: 80, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'fullname', title: this.msg('归属人'), minWidth: 80, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'companyName', title: this.msg('归属公司'), minWidth: 80, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'expBatch', title: this.msg('批次'), minWidth: 80, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'storeName', title: this.msg('仓库名'), minWidth: 80, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
            ]
        },
        list(refresh){

            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
            }

            var param = this.$kit.rebuildQuery(this.query);

            if(param.codes){
                let cs = param.codes.split(/[\s,]+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                param.codes = css.join(",");
            }
            if(param.createNames){
                let cs = param.createNames.split(/[\s,]+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                param.createNames = css.join(",");
            }
            if(param.userNames){
                let cs = param.userNames.split(/[\s,]+/);
        
                let css = [];
                for(let i=0; i<cs.length; i++){
                    if(cs[i]) css.push(cs[i]);
                }
                param.userNames = css.join(",");
            }

            this.$axios.post(this.$kit.api.pasteRecord.list, param)
                .then((result) => {
                    if(result.status){
                        this.pasteRecords = result.data.list;
                        this.query.pageTotal = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        //点击行，选中行
        checkRow({row, $event, column, columnIndex}){
            //如果点击checkbox 则不处理
            // console.log(columnIndex);
            let className = $event.target.className;
           
            if(columnIndex > 0){  //选择 
                if(column.property == 'code'){  //订单编号
                    if(className.indexOf('status-cell')>-1){
                        var table =  this.$refs.dataTable;
                        table.clearCheckboxRow();
                        table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
                        var selectes = this.$refs.dataTable.getCheckboxRecords();
                        if(selectes.length>0){
                            let row = selectes[0];
                            this.$refs.traceRef.showTracks(row.stockId, 0);
                        }
                    }
                }
            }
        },
        reset(){
            this.$kit.clearQuery(this.query);
        },
        doExport(){
            this.$refs.dataTable.openExport({ isPrint: false })
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        //计数统计
        doRecordCount(){
            this.recordData.splice(0, this.recordData.length);

            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                //根据搜索条件进行统计
                if(!this.query.Date || this.query.Date.length==0){
                    this.$message(this.msg('请先选择日期范围'));
                    return;
                }
                var _this = this;
                this.$confirm(this.msg('确定要根据搜索条件进行计数统计吗?'), this.msg('提示'), {
                    confirmButtonText: this.msg('确定'),
                    cancelButtonText: this.msg('取消'),
                    type: 'warning'
                }).then(() => {
                    let param = _this.$kit.rebuildQuery(_this.query);
                    if(param.codes){
                        let cs = param.codes.split(/[\s,]+/);
                
                        let css = [];
                        for(let i=0; i<cs.length; i++){
                            if(cs[i]) css.push(cs[i]);
                        }
                        param.codes = css.join(",");
                    }
                    if(param.createNames){
                        let cs = param.createNames.split(/[\s,]+/);
                
                        let css = [];
                        for(let i=0; i<cs.length; i++){
                            if(cs[i]) css.push(cs[i]);
                        }
                        param.createNames = css.join(",");
                    }
                    if(param.userNames){
                        let cs = param.userNames.split(/[\s,]+/);
                
                        let css = [];
                        for(let i=0; i<cs.length; i++){
                            if(cs[i]) css.push(cs[i]);
                        }
                        param.userNames = css.join(",");
                    }
                    _this.$axios.post(_this.$kit.api.pasteRecord.count, param)
                    .then((result) => {
                        if(result.status){
                            let resData = result.data;
                            resData.forEach(e => (
                                _this.recordData.push({
                                    username: e.username,
                                    amount: e.amount,
                                    createName: e.createName
                                })
                            ));
                            _this.recordRTitle = _this.msg('计数统计');
                            _this.recordVisiable = true;
                        }else{
                            _this.$message(result.msg || _this.msg('获取失败'));
                        }
                    });
                }).catch((err) => {
                    // console.log(err);
                });

            }else{
                // 按照username分组统计数量
                const groupedData = {};
                const groupedName = {};
                selectes.forEach(record => {
                    const username = record.username || '未知用户';
                    if (groupedData[username]) {
                        groupedData[username]++;
                    } else {
                        groupedData[username] = 1;
                    }
                    const createName = record.createrName || '未知用户';
                    if (!groupedName[username]) {
                        groupedName[username] = createName;
                    }
                });
                
                // 转换为表格所需的数组格式
                this.recordData = Object.keys(groupedData).map(username => ({
                    username: username,
                    amount: groupedData[username],
                    createName: groupedName[username]
                }));
                this.recordRTitle = this.msg('计数统计');
                this.recordVisiable = true;
            }
            
        },
        //去重统计
        doRecordCountDistinct(){
            this.recordData.splice(0, this.recordData.length);
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                //根据搜索条件进行统计
                if(!this.query.Date || this.query.Date.length==0){
                    this.$message(this.msg('请先选择日期范围'));
                    return;
                }
                var _this = this;
                this.$confirm(this.msg('确定要根据搜索条件进行去重统计吗?'), this.msg('提示'), {
                    confirmButtonText: this.msg('确定'),
                    cancelButtonText: this.msg('取消'),
                    type: 'warning'
                }).then(() => {
                    let param = _this.$kit.rebuildQuery(_this.query);
                    if(param.codes){
                        let cs = param.codes.split(/[\s,]+/);
                
                        let css = [];
                        for(let i=0; i<cs.length; i++){
                            if(cs[i]) css.push(cs[i]);
                        }
                        param.codes = css.join(",");
                    }
                    if(param.createNames){
                        let cs = param.createNames.split(/[\s,]+/);
                
                        let css = [];
                        for(let i=0; i<cs.length; i++){
                            if(cs[i]) css.push(cs[i]);
                        }
                        param.createNames = css.join(",");
                    }
                    if(param.userNames){
                        let cs = param.userNames.split(/[\s,]+/);
                
                        let css = [];
                        for(let i=0; i<cs.length; i++){
                            if(cs[i]) css.push(cs[i]);
                        }
                        param.userNames = css.join(",");
                    }
                    _this.$axios.post(_this.$kit.api.pasteRecord.countDistinct, param)
                    .then((result) => {
                        if(result.status){
                            let resData = result.data;
                            resData.forEach(e => (
                                _this.recordData.push({
                                    username: e.username,
                                    amount: e.amount,
                                    createName: e.createName
                                })
                            ));
                            _this.recordRTitle = _this.msg('去重统计');
                            _this.recordVisiable = true;
                        }else{
                            _this.$message(result.msg || _this.msg('获取失败'));
                        }
                    });
                }).catch((err) => {
                    // console.log(err);
                });
            }else{
                // 按照username分组统计唯一code数量
                const groupedData = {};
                const groupedName = {};
                selectes.forEach(record => {
                    const username = record.username || '未知用户';
                    const code = record.code;
                    
                    const createName = record.createrName || '未知用户';
                    if (!groupedName[username]) {
                        groupedName[username] = createName;
                    }
    
                    // 如果该用户还没有记录，初始化一个Set来存储唯一的code
                    if (!groupedData[username]) {
                        groupedData[username] = new Set();
                    }
                    
                    // 将code添加到Set中（自动去重）
                    if (code) {
                        groupedData[username].add(code);
                    } else {
                        // 如果没有code，用一个唯一标识代替
                        groupedData[username].add(`no-code-${Date.now()}-${Math.random()}`);
                    }
                });
                
                // 转换为表格所需的数组格式，Set的size就是唯一code的数量
                this.recordData = Object.keys(groupedData).map(username => ({
                    username: username,
                    amount: groupedData[username].size,
                    createName: groupedName[username]
                }));
                this.recordRTitle = this.msg('去重统计');
                this.recordVisiable = true;
            }
            
        },
        //打开账号统计
        doRecordCountUser(){
            this.recordUsername = null;
            this.type = null;
            this.recordRadio = "1";
            this.recordFullname = null;
            this.userRecordAmount = 0;
            this.created = [];
            this.recordUserVisiable = true;
        },
        openHelp(){//打开帮助文档
            //打开链接
            window.open("https://www.kdocs.cn/l/cvVAz9KBmrWM");
        },
        doRecordUser(){
            if(!this.recordUsername && !this.recordFullname){
                this.$message(this.msg('请输入操作账号或者操作人员'));
                return;
            }
            if(this.created.length == 0){
                this.$message(this.msg('请选择操作时间'));
                return;
            }
            var _this = this;
            let param = {
                recordUsername: this.recordUsername,
                recordFullname: this.recordFullname,
                type: this.type,
                recordDis: this.recordRadio,
                startDate: this.created[0],
                endDate: this.created[1]
            }
            this.$axios.post(_this.$kit.api.pasteRecord.countUser, param)
                .then((result) => {
                    if(result.status){
                        _this.userRecordAmount = result.data;
                        if(result.data == 0){
                            _this.$message(_this.msg('该账号无记录'));
                            return;
                        }
                        _this.$message('成功查询到'+result.data+'条记录');
                    }else{
                        _this.$message(_this.msg('查询失败！'));
                    }
                });
        },
        copyResult(){
            // 检查是否有选中的记录
            if(this.recordData.length === 0){
                this.$message(this.msg('无数据'));
                return;
            }
            
            // 将每个记录的username和amount用冒号拼接，每个记录之间用换行符分隔
            var result = this.recordData.map(record => `${record.createName}(${record.username}):${record.amount}`).join('\n');
            
            // 创建临时textarea元素用于复制
            const textarea = document.createElement('textarea');
            textarea.value = result;
            textarea.style.position = 'fixed';
            textarea.style.left = '-999999px';
            textarea.style.top = '-999999px';
            document.body.appendChild(textarea);
            
            // 选中内容并复制到剪贴板
            textarea.select();
            document.execCommand('copy');
            
            // 移除临时元素
            document.body.removeChild(textarea);
            
            // 显示复制成功提示
            this.$message(this.msg('复制成功'));
        },
        downloadResult(){
            
            var titles = [['姓名','数量']];
            this.recordData.forEach(res => titles.push([res.username, res.amount]));
 
            var filename = this.importTemplate? this.templates.find(t => t.id == this.importTemplate).name+".xlsx" : this.recordRTitle+'-'+new Date().getTime()+'.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);

        },
    },
}
</script>

<style lang="scss" scoped>
.detail-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.detail-cell1{cursor:pointer; display:inline-block; margin-right:5px;}
.status-cell{cursor:pointer; display:inline-block; margin-right:5px;}
</style>
